import { DataSource } from "@essenza/core";
import {Vista, useVista, useApp} from "@essenza/react";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import { JobForm } from "../view/job_form";
import {StudentForm} from "../view/student_form";

function JobFormVistaController(c) {
    c.skin = JobFormVista;
}

export function JobFormVista() {
    const [ctx, control] = useVista(JobFormVistaController);
    const job = useLocation().state;
    const app = useApp();

    if(!app.session.complete){
        message.warning("Completa il profilo prima di pubblicare un annucio.");
        control.navigate("/profile");
    }

    return (
        <Vista context={ctx} >
            <div className="w100 py-md">
                <div className="centered max-width-sm text-center">
                    <h1 className="spacing-b10">{job?'Dettaglio Offerta':'Trova il tuo prossimo talento!'}</h1>
                    <JobForm npath="/offerte"  source={new DataSource(job ||{},null, "joboffer")}/>
                </div>
            </div>
        </Vista>
    )
}